import styled from "styled-components";
import { Body, Small } from "../../../styles/stringStyles";
import { hexWithOpacity } from "../../../utils/hexWithOpacity";
import { CustomButton } from "../../buttons/CustomButton";

type Props = {
  text: string;
  selected: boolean;
  onClick?: () => void;
  bgColor?: string;
  color?: string;
  inactiveColor?: string;
  isSmall?: boolean;
  className?: string;
};

export const TagButton = ({
  text,
  selected,
  onClick,
  bgColor,
  color,
  inactiveColor,
  isSmall,
  className,
}: Props) => {
  return (
    <StyledButton
      $selected={selected}
      onClick={onClick}
      $bgColor={bgColor}
      $isSmall={isSmall}
      className={className}
    >
      {isSmall ? (
        <StyledSmall
          $selected={selected}
          $color={color}
          $inactiveColor={inactiveColor}
        >
          {text}
        </StyledSmall>
      ) : (
        <StyledBody
          $selected={selected}
          $color={color}
          $inactiveColor={inactiveColor}
        >
          {text}
        </StyledBody>
      )}
    </StyledButton>
  );
};

const StyledButton = styled(CustomButton)<{
  $selected: boolean;
  $bgColor?: string;
  $isSmall?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, $selected, $bgColor }) =>
    $selected
      ? ($bgColor ?? theme.colors.primary)
      : hexWithOpacity(theme.colors.light, 0.5)};
  border-radius: 8px;
  padding: ${(props) => (props.$isSmall ? "4px 12px" : "8px 12px")};
  min-width: 80px;
`;

const StyledBody = styled(Body)<{
  $selected: boolean;
  $color?: string;
  $inactiveColor?: string;
}>`
  color: ${({ theme, $selected, $color, $inactiveColor }) =>
    $selected
      ? ($color ?? theme.colors.white)
      : ($inactiveColor ?? theme.colors.medium)};
`;

const StyledSmall = styled(Small)<{
  $selected: boolean;
  $color?: string;
  $inactiveColor?: string;
}>`
  color: ${({ theme, $selected, $color, $inactiveColor }) =>
    $selected
      ? ($color ?? theme.colors.white)
      : ($inactiveColor ?? theme.colors.medium)};
`;
